import Tool from '../../common/tool';
import { buildHelpArticleListUrl } from './helpProductUrl';
import HelpSearchSuggest from './helpSearchSuggest';
var GUIDE_ITEMS_PER_SLIDE = 12;
var HelpMain = /** @class */ (function () {
    function HelpMain() {
        this.goodsCategoryId = 0;
        this.guideSwiper = null;
        this.searchBoxDom = document.getElementById('search');
        this.displayDom = document.getElementById('operate-goods');
        this.init();
    }
    HelpMain.prototype.init = function () {
        this.handleSearch();
        this.handleGuideCarousel();
        this.handleKnowledgeSection();
    };
    HelpMain.prototype.handleSearch = function () {
        var inputDom = this.searchBoxDom.querySelector('.search-input');
        var searchBtn = this.searchBoxDom.querySelector('.search-btn');
        var goSearch = function (keyword) {
            var value = (keyword !== null && keyword !== void 0 ? keyword : inputDom.value).trim();
            if (!value) {
                alert('关键词不能为空！');
                return;
            }
            window.open("/searchResult?keywords=".concat(encodeURIComponent(value), "&tab=article&page=1"));
        };
        var searchSuggest = new HelpSearchSuggest(this.searchBoxDom, goSearch);
        searchBtn.addEventListener('click', function () { return goSearch(); });
        inputDom.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
                if (!searchSuggest.handleEnter()) {
                    goSearch();
                }
            }
        });
    };
    HelpMain.prototype.handleGuideCarousel = function () {
        var _this = this;
        var tabDomList = Tool.$_selectAll(this.displayDom, '.daetool-guide-box__tabs li');
        tabDomList.forEach(function (item) {
            item.addEventListener('click', function () {
                var nextId = Number(item.getAttribute('data-id'));
                if (_this.goodsCategoryId === nextId) {
                    return;
                }
                tabDomList.forEach(function (tab) { return tab.classList.remove('active'); });
                item.classList.add('active');
                _this.goodsCategoryId = nextId;
                _this.renderGuideSwiper(_this.getProductsByCategory(nextId));
            });
        });
        this.renderGuideSwiper(this.getProductsByCategory(this.goodsCategoryId));
    };
    HelpMain.prototype.getProductsByCategory = function (categoryId) {
        var category = guideCategories.find(function (item) { return item.id === categoryId; });
        return category ? category.children : [];
    };
    HelpMain.prototype.getSlidesHtml = function (products) {
        if (!products.length) {
            return '<div class="swiper-slide"><div class="daetool-guide-grid daetool-guide-grid--empty"><p>暂无产品</p></div></div>';
        }
        var slides = [];
        for (var i = 0; i < products.length; i += GUIDE_ITEMS_PER_SLIDE) {
            var chunk = products.slice(i, i + GUIDE_ITEMS_PER_SLIDE);
            var cards = chunk
                .map(function (item) {
                return "<a class=\"daetool-guide-card\" href=\"".concat(buildHelpArticleListUrl(item.details_url), "\">\n              <img class=\"daetool-guide-card__logo\" src=\"").concat(item.i_url, "\" alt=\"\">\n              <span class=\"daetool-guide-card__name\">").concat(item.g_name, "</span>\n            </a>");
            })
                .join('');
            slides.push("<div class=\"swiper-slide\"><div class=\"daetool-guide-grid\">".concat(cards, "</div></div>"));
        }
        return slides.join('');
    };
    HelpMain.prototype.renderGuideSwiper = function (products) {
        var _this = this;
        var swiperEl = Tool.$_select(this.displayDom, '#daetool-guide-swiper');
        var wrapperEl = Tool.$_select(swiperEl, '.swiper-wrapper');
        wrapperEl.innerHTML = this.getSlidesHtml(products);
        if (this.guideSwiper) {
            this.guideSwiper.destroy(true, true);
            this.guideSwiper = null;
        }
        if (typeof Swiper === 'undefined') {
            console.error('[help] Swiper 未加载，产品一览表轮播无法初始化');
            return;
        }
        // 等 DOM 写入后再初始化，避免 Swiper 只渲染第一屏或叠在一起
        window.requestAnimationFrame(function () {
            _this.guideSwiper = new Swiper('#daetool-guide-swiper', {
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 400,
                watchOverflow: false,
                observer: true,
                observeParents: true,
                pagination: {
                    el: '#daetool-guide-swiper-wrap .daetool-guide-swiper__pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '#daetool-guide-swiper-wrap .daetool-guide-swiper__next',
                    prevEl: '#daetool-guide-swiper-wrap .daetool-guide-swiper__prev',
                },
            });
        });
    };
    HelpMain.prototype.handleKnowledgeSection = function () {
        var _a;
        var section = document.getElementById('help-knowledge');
        if (!section) {
            return;
        }
        var tabs = Tool.$_selectAll(section, '.daetool-help-knowledge__tab');
        var panels = Tool.$_selectAll(section, '.daetool-help-knowledge__panel');
        var moreLink = document.getElementById('help-knowledge-more');
        var syncTabIcons = function () {
            tabs.forEach(function (tab) {
                var img = tab.querySelector('.daetool-help-knowledge__tab-icon');
                if (!img) {
                    return;
                }
                var isActive = tab.classList.contains('is-active');
                var nextSrc = isActive ? img.dataset.iconActive : img.dataset.iconDefault;
                if (nextSrc) {
                    img.src = nextSrc;
                }
            });
        };
        var syncPanel = function (alias) {
            tabs.forEach(function (tab) {
                var isActive = tab.getAttribute('data-alias') === alias;
                tab.classList.toggle('is-active', isActive);
                tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });
            syncTabIcons();
            panels.forEach(function (panel) {
                panel.classList.toggle('is-active', panel.getAttribute('data-panel') === alias);
            });
            if (moreLink) {
                moreLink.href = "/".concat(alias);
            }
        };
        tabs.forEach(function (tab) {
            tab.addEventListener('click', function () {
                var alias = tab.getAttribute('data-alias');
                if (!alias) {
                    return;
                }
                syncPanel(alias);
            });
        });
        var activeTab = section.querySelector('.daetool-help-knowledge__tab.is-active');
        var defaultAlias = (activeTab === null || activeTab === void 0 ? void 0 : activeTab.getAttribute('data-alias')) || ((_a = tabs[0]) === null || _a === void 0 ? void 0 : _a.getAttribute('data-alias'));
        if (defaultAlias) {
            syncPanel(defaultAlias);
        }
        this.bindKnowledgeTabIconFallback(section);
    };
    /** 图标缺失时回退到 news / news_color */
    HelpMain.prototype.bindKnowledgeTabIconFallback = function (section) {
        var icons = Array.from(section.querySelectorAll('.daetool-help-knowledge__tab-icon'));
        icons.forEach(function (img) {
            img.addEventListener('error', function () {
                var tab = img.closest('.daetool-help-knowledge__tab');
                var isActive = tab === null || tab === void 0 ? void 0 : tab.classList.contains('is-active');
                var fallback = isActive ? img.dataset.iconFallbackActive : img.dataset.iconFallback;
                if (fallback && img.src !== fallback) {
                    img.src = fallback;
                }
            });
        });
    };
    return HelpMain;
}());
export default HelpMain;
